// 用户api
import request from "@/config/_request";
import qs from "qs";
import store from "@/vuex";

// 教师登录
export function login(params) {
  return request({
    url: "/api/login",
    data: qs.stringify(params),
    method: "post",
  });
}

// 学生登录
export function loginStu(params) {
  return request({
    url: "/api/stu/login",
    data: qs.stringify(params),
    method: "post",
  });
}


// 用户角色
export function getUserRole(params) {
  return request({
    url: "/api/get/role/list",
    params,
    method: "get",
  });
}

// 获取学校对应的科目列表
export function getUserSubjectList(params, admin) {
  return request({
    url: "/api/get/subject/list",
    params,
    method: "get",
    admin: admin
  });
}

// 登录
export function addUser(params) {
  return request({
    url: "/api/add/user",
    data: qs.stringify(params),
    method: "post",
  });
}

// 获取用户信息
export function getUserInfo(params) {
  return request({
    url: "/api/get/user",
    params,
    method: "get",
  });
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: "/api/get/user/list",
    params,
    method: "get",
  });
}

// 更新用户信息
export function updateUser(params) {
  return request({
    url: "/api/update/user",
    data: qs.stringify(params),
    method: "post",
  });
}

//更新用户token信息 不用了
export function freshToken(params) {
  return request({
    url: "/api/fresh/token",
    params,
    method: "get",
  });
}



//删除员工
export function deleteUser(params) {
  return request({
    url: "/api/delete/user",
    data: qs.stringify(params),
    method: "post",
  });
}


//刷新账号信息
export async function freshData(params) {
  let postRs = null;
  if (store.state.user.identity === 1) {
    postRs = await tchFreshData(params)
    postRs.identity = 1;
    // return tchFreshData(params)
  } else {
    postRs = await stuFreshData(params)
    postRs.userInfo = postRs.stuUserInfo
    postRs.identity = 2;
    // return stuFreshData(params)
  }
  return postRs;
  // return request({
  //   url: "/api/fresh/data",
  //   params,
  //   method: "get",
  // });
}

/**
 * 教师端 刷新老师信息数据
 * @param {*} params 
 * @returns 
 */
const tchFreshData = (params) => {
  return request({
    url: "/java-api/school/tch/freshData",
    data: params,
    method: "post"
  })
}
/**
 * 学生端 刷新信息数据
 * @param {*} params 
 * @returns 
 */
const stuFreshData = (params) => {
  return request({
    url: "/java-api/student/stu/freshData",
    data: params,
    method: "post"
  })
}